import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyPhotoMarqueePageWidthLayout = loadable(
  () => import(/* webpackChunkName: "content/guest/header/photoMarqueePageWidth" */ './PhotoMarqueePageWidth'),
  'PhotoMarqueePageWidthLayout',
);
